import { all, call, takeLeading, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR, SUCCESS } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

import {
  requestCreateInitialSocialPerson,
  requestRegister,
  requestCreateInitialPerson,
  requestKeycloakRegistration,
} from './registration.actions';
import {
  getCreateInitialSocialPersonRequest,
  getRegisterRequest,
  getCreateInitialPersonRequest,
  getKeycloakRegistrationRequest,
} from './registration.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';

export function* performCreateInitialSocialPersonRequest({ payload }) {
  const { initialPerson, onSuccess, navigate } = payload;

  try {
    yield put(addSpinner('Creating Initial User'));

    const [endpoint, options] = getCreateInitialSocialPersonRequest(initialPerson);

    const { data } = yield call(axios, endpoint, options);

    yield call(navigate, `/registration/${data?.personExternalReference}`);

    if (onSuccess) {
      yield call(onSuccess);
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
    yield call(navigate, '/');
  } finally {
    yield put(removeSpinner('Creating Initial User'));
  }
}

export function* watchForCreateInitialSocialPersonRequest() {
  yield takeLeading(requestCreateInitialSocialPerson.type, performCreateInitialSocialPersonRequest);
}

export function* performCreateInitialPersonRequest({ payload }) {
  const { initialPerson, onSuccess } = payload;

  try {
    yield put(addSpinner('Creating Initial User'));

    const [endpoint, options] = getCreateInitialPersonRequest(initialPerson);

    yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(addSystemNotice({ type: SUCCESS, message: 'Please check your inbox for an activation email' }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Creating Initial User'));
  }
}

export function* watchForCreateInitialPersonRequest() {
  yield takeLeading(requestCreateInitialPerson.type, performCreateInitialPersonRequest);
}

export function* performRegisterRequest({ payload }) {
  const { registration, onSuccess } = payload;

  try {
    yield put(addSpinner('Registering'));

    const [endpoint, options] = getRegisterRequest(registration);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Registering'));
  }
}

export function* watchForRegisterRequest() {
  yield takeLeading(requestRegister.type, performRegisterRequest);
}

export function* performKeycloakRegistrationRequest({ payload }) {
  const { keycloakRegistration, onSuccess } = payload;

  try {
    yield put(addSpinner('Creating User'));

    const [endpoint, options] = getKeycloakRegistrationRequest(keycloakRegistration);

    yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(addSystemNotice({ type: SUCCESS, message: 'Please follow the steps to complete registration process' }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Creating User'));
  }
}

export function* watchForKeycloakRegistrationRequest() {
  yield takeLeading(requestKeycloakRegistration.type, performKeycloakRegistrationRequest);
}

export default function* registrationSaga() {
  yield all([
    watchForCreateInitialPersonRequest(),
    watchForRegisterRequest(),
    watchForCreateInitialSocialPersonRequest(),
    watchForKeycloakRegistrationRequest(),
  ]);
}
